import * as React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { Auth, Cache } from 'aws-amplify';
import Routes from '../../constants/Routes';
import { withRouter } from 'react-router';

type Props = {
  code: string;
  confirm: () => void;
  setCode: () => void;
  updateCode: () => void;
};

const ConfirmSignup: React.SFC<Props> = ({ code, updateCode, confirm }) => (
  <div>
    <p>Confirm Signup.</p>
    <form onSubmit={confirm}>
      <input type="text" value={code} onChange={updateCode} />
      <button type="submit">Confirm</button>
    </form>
  </div>
);

export default compose(
  withRouter,
  withState('code', 'setCode', ''),
  withHandlers({
    updateCode: ({ setCode }) => (event: React.FormEvent<HTMLInputElement>) =>
      setCode(event.currentTarget.value),
    confirm: ({ code, history }) => async (event: React.FormEvent<HTMLInputElement>) => {
      event.preventDefault();
      try {
        const username = Cache.getItem('registerUsername');
        console.log('confirm', username, code);
        const result = await Auth.confirmSignUp(username, code);
        if (result) history.push(Routes.main);
        console.log(result);
      } catch (error) {
        console.log('ERROR:confirm', error);
      }
    },
  }),
)(ConfirmSignup);



// WEBPACK FOOTER //
// ./src/containers/Auth/ConfirmSignup.tsx